import { ItineraryCheckerService, ItineraryCheckupErrors } from './../itinerary-checker.service';
import { MatDialog } from '@angular/material/dialog';
import { ElementRef, Input, OnDestroy } from '@angular/core';
import { ViewChild } from '@angular/core';
import { CouponService } from './../coupon.service';
import { TravelAdvisorProfileServiceFactory } from './../travel-advisor-profile.service';
import { CartService } from './../cart.service';
import { Itinerary } from './../itineray.model';
import { ActivatedRoute } from '@angular/router';
import { environment } from './../../environments/environment';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserService } from '../user.service';
import { first } from 'rxjs/operators';
import { ItineraryCheckupDialogComponent } from '../itinerary-checkup-dialog/itinerary-checkup-dialog.component';
import { ItineraryReviewCheckupDialogComponent } from '../itinerary-review-checkup-dialog/itinerary-review-checkup-dialog.component';
import { ItineraryWorkflowService } from '../itinerary-workflow.service';
import { firestore } from 'firebase';

@Component({
  selector: 'app-itinerary-preview',
  templateUrl: './itinerary-preview.component.html',
  styleUrls: ['./itinerary-preview.component.css']
})
export class ItineraryPreviewComponent implements OnInit, OnDestroy {

  itinerary: Itinerary;

  previewIframeUrl: SafeResourceUrl;

  hasErrors: boolean = null;

  rendered: boolean;

  @Input()
  reviewIntent?: boolean;

  errors: ItineraryCheckupErrors;

  onMessageFn: any;

  @ViewChild("iframe", { static: true }) iframeElement: ElementRef<HTMLIFrameElement>;
  @ViewChild("iframeContainer", { static: true }) iframeContainerElement: ElementRef<HTMLDivElement>;

  constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute, private cartService: CartService, private travelAdvisorProfileServiceFactory: TravelAdvisorProfileServiceFactory, private couponService: CouponService, private matDialog: MatDialog, private itineraryCheckerService: ItineraryCheckerService, private itineraryWorkflowService: ItineraryWorkflowService) { }

  ngOnInit() {
    this.itinerary = this.route.parent.snapshot.data.itinerary;
    const locale = this.itinerary.locale ?? "it";
    this.previewIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.rendererPreviewUrl[locale]);

    // TODO rigenera tutto

    const that = this;
    this.onMessageFn = function receiveMessage(event) {
      // TODO: Do we trust the sender of this message?  (might be different from what we originally opened, for example).
      //if (event.origin !== "https://wanderoo.typeform.com" && event.origin !== "http://localhost:5000" && event.origin !== "https://wanderoo-website-dev.firebaseapp.com" && event.origin !== "https://wanderoo-website.firebaseapp.com" && event.origin !== "https://www.quovado.com")
      //  return;

      if (event.data.type === "wanderoo-renderer-ready") {
        that.postData();
      }

      if (event.data.type === "wanderoo-renderer-rendered") {
        that.checkup(event.data.data.overflowErrorsCount);
        window.removeEventListener('message', that.onMessageFn, false);
        that.onMessageFn = null;
        that.rendered = true;
      }

    };
    window.addEventListener("message", this.onMessageFn, false);
    this.scale();
  }

  ngOnDestroy(): void {
    if (this.onMessageFn) {
      window.removeEventListener('message', this.onMessageFn, false);
      this.onMessageFn = null;
    }
  }

  async postData() {
    const itinerary: any = Object.assign({}, this.itinerary);

    // FIXME: migliorare posizionamento di questo codice
    const cart: any = await this.cartService.get(this.itinerary.cart.id).pipe(first()).toPromise();
    const coupon: any = this.itinerary.coupon ? (await this.couponService.get(this.itinerary.coupon.id).pipe(first()).toPromise()) : null;
    const travelAdvisorProfile: any = this.itinerary.assignee ? (await this.travelAdvisorProfileServiceFactory.create(this.itinerary.assignee.id).get("default").pipe(first()).toPromise()) : null;

    const plainItinerary = JSON.parse(JSON.stringify(itinerary, (key: string, value: any) => {
      if (value instanceof firestore.GeoPoint) {
        return {
          latitude: (value as firestore.GeoPoint).latitude,
          longitude: (value as firestore.GeoPoint).longitude,
        };
      } else if (value instanceof firestore.Timestamp) {
        return {
          seconds: (value as firestore.Timestamp).seconds,
          nanoseconds: (value as firestore.Timestamp).nanoseconds
        };
      } else if (value instanceof firestore.DocumentReference) {
        return undefined;
      }
      return value;
    }));

    if (this.iframeElement?.nativeElement?.contentWindow) {
      this.iframeElement.nativeElement.contentWindow.postMessage({ type: "wanderoo-renderer-data", data: { itinerary: plainItinerary, cart, travelAdvisorProfile, coupon }, mode: "preview" }, "*");
    } else {
      console.warn("Preview iframe has gone...");
    }
  }

  scale() {
    const container = this.iframeContainerElement.nativeElement;
    const targetW = 1920;
    const targetH = 1080;
    const scaleW = container.parentElement.clientWidth * 1 / targetW;
    const scaleH = container.parentElement.clientHeight * 1 / targetH;
    const scale = Math.min(scaleW, scaleH);
    container.style.transform = "scale(" + scale + ")";
    container.style.width = targetW + "px"
    container.style.height = targetH + "px"
    container.style.marginLeft = (-targetW * scale / 2) + "px";
    container.style.marginTop = (-targetH * scale / 2) + "px";
  }

  async checkup(overflowErrorsCount?: number) {
    const errors: ItineraryCheckupErrors = await this.itineraryCheckerService.check(this.itinerary);
    if (overflowErrorsCount) {
      errors.overflows = [];
      for (let i = 0; i < overflowErrorsCount; i++) {
        errors.overflows.push({
          message: "#" + (i + 1) + ": Il TESTO riquadrato in rosso è troppo lungo ed esce dalla casella di testo.",
          routerLink: null
        });
      }
    }

    let valid = true;
    for (const key of Object.keys(errors)) {
      valid = valid && errors[key].length === 0;
    }
    this.errors = errors;
    this.hasErrors = !valid;
  }

  showCheckupDialog() {
    this.matDialog.open(ItineraryCheckupDialogComponent, {
      width: '50%',
      data: this.errors
    });
  }

  async showReviewDialog() {
    const dialogRef = this.matDialog.open(ItineraryReviewCheckupDialogComponent, {
      width: '50%',
      data: this.errors
    });

    const dialogResult = await dialogRef.afterClosed().toPromise();
    if (dialogResult === true) {
      this.itineraryWorkflowService.review(this.itinerary);
    }

  }

}
